<mat-form-field class="w-100" [class]="class">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    maxlength="100"
    autocomplete="off"
    [formControl]="_formControl"
    [matAutocomplete]="auto"
    [readonly]="readOnly"
    (focus)="onFocus()"
    (keyup)="onKeyUp($event)" 
    (blur)="onBlur()"/>
  <mat-autocomplete
    [displayWith]="getDisplayName"
    (optionSelected)="onItemSelected($event)"
    #auto="matAutocomplete">
    @for(item of filteredItems | async; track item) {
      <mat-option [value]="item">
        {{ getItemName(item) }}
      </mat-option>
      @if(showDivider(item)) {
      <mat-divider></mat-divider>
      }
    }
  </mat-autocomplete>
  @if(!readOnly) {
  <button
    mat-icon-button
    matSuffix
    type="button"
    (click)="onRemoveSelectedItem()"
    [disabled]="_formControl.disabled">
    <mat-icon>clear</mat-icon>
  </button>
  }
  <span matSuffix>
    <ng-content></ng-content>
  </span>
  @for(error of errors; track error) {
  <mat-error>{{ error }}</mat-error>
  }
</mat-form-field>
